import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Inline from './inline';
export default function Paragraph(_ref) {
  var children = _ref.children,
    dataAttributes = _ref.dataAttributes,
    localId = _ref.localId;
  return (
    /*#__PURE__*/
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    React.createElement("p", _extends({}, dataAttributes, {
      "data-local-id": localId
    }), /*#__PURE__*/React.createElement(Inline, null, children))
  );
}